import React from "react";

interface FavoriteIconProps {
    isFavourite: boolean;
}

export const FavoriteIcon: React.FC<FavoriteIconProps> = ({ isFavourite }) => {
    return !isFavourite ? (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10 2.5L8.0417 7.3L2.8667 7.68333L6.83337 11.0333L5.5917 16.0667L10 13.3333M10 2.5L11.9584 7.3L17.1334 7.68333L13.1667 11.0333L14.4084 16.0667L10 13.3333" stroke="#C3CFE7" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>

    ) : 
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10 2.5L11.9584 7.3L17.1334 7.68333L13.1667 11.0333L14.4084 16.0667L10 13.3333L5.5917 16.0667L6.83337 11.0333L2.8667 7.68333L8.0417 7.3L10 2.5Z" fill="#0068F5"/>
        <path d="M10 2.5L8.0417 7.3L2.8667 7.68333L6.83337 11.0333L5.5917 16.0667L10 13.3333M10 2.5L11.9584 7.3L17.1334 7.68333L13.1667 11.0333L14.4084 16.0667L10 13.3333" stroke="#0068F5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
;
};